module.exports = __webpack_public_path__ + "static/mockup_wyborek-5d2a428477e3af6da81ef178a93bf50b.png";